import {
    OverviewDataPlot,
    OverviewPanel,
    OverviewRangebar,
    useOverviewQuery,
    useOverviewRange,
} from '../../features/overview';
import './OverviewPage.css';

function Overview({ isMobile }: any) {
    const { rangetype, setRangetype, timeKeys, setTimeKeys } = useOverviewRange();
    // Pending only until the first response: a range switch keeps the previous
    // range on screen instead of flashing back to skeletons.
    const { data, isPending } = useOverviewQuery(timeKeys);

    return (
        <div className='overview-shell'>
            <OverviewPanel
                uploadToday={data?.upload_day ?? 0}
                errorToday={data?.error_day ?? 0}
                uploadWeek={data?.upload_week ?? 0}
                errorWeek={data?.error_week ?? 0}
                isLoading={isPending}
                isMobile={isMobile}
            />
            <OverviewRangebar
                rangetype={rangetype}
                setRangetype={setRangetype}
                timeKeys={timeKeys}
                setTimeKeys={setTimeKeys}
                isMobile={isMobile}
            />
            <OverviewDataPlot
                records
                allCountList={data?.upload_every_day ?? {}}
                errCountList={data?.error_every_day ?? {}}
                overviewRecords={data?.records.Items ?? []}
                normal={data?.normal ?? {}}
                abnormal={data?.abnormal ?? {}}
                failAverageTime={data?.fail_average_time ?? 0}
                errRate={data?.fail_rate ?? 0}
                timeKeys={timeKeys}
                isLoading={isPending}
                isMobile={isMobile}
            />
        </div>
    );
}

export default Overview;
